import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle, X } from "lucide-react";

type EnvResponse = { environment: "production" | "staging" | "development" };

const DISMISS_STORAGE_KEY = "pp.stagingBannerDismissed";

export function StagingBanner() {
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(DISMISS_STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const { data } = useQuery<EnvResponse>({
    queryKey: ["/api/env"],
    staleTime: 5 * 60 * 1000,
  });

  if (data?.environment !== "staging" || dismissed) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_STORAGE_KEY, "1");
    } catch {
      void 0;
    }
    setDismissed(true);
  };

  return (
    <div
      className="sticky top-0 z-50 border-b border-amber-300 bg-amber-100 text-amber-900"
      data-testid="banner-staging"
    >
      <div className="px-4 py-2 flex items-center gap-3">
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-700" />
        <div className="flex-1 min-w-0 text-sm font-semibold" data-testid="text-staging-banner">
          STAGING — not production. Data, payments, and notifications here are for testing only.
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 p-1 rounded hover:bg-amber-200 text-amber-800"
          aria-label="Dismiss staging banner"
          data-testid="button-dismiss-staging-banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
